import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAdvisorCheck } from "@/hooks/use-advisor-check";
import { Loader2 } from "lucide-react";

export function AdvisorGuard({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { data, isLoading } = useAdvisorCheck();

  useEffect(() => {
    if (!isLoading && !data?.isAdvisor) {
      navigate("/", { replace: true });
    }
  }, [data, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!data?.isAdvisor) {
    return null;
  }

  return <>{children}</>;
}
